/*
 * Copyright (c) 2024. Bolmate B.V.
 */

import React, {MouseEventHandler, useMemo} from 'react';

import Chart from 'react-apexcharts';

import {BolSearchTerm} from '../../util/interfaces';

interface Props {
    onClickRelated: (term: string) => MouseEventHandler;
    relatedTerms: Array<BolSearchTerm>;
    width?: number | string;
    height?: number | string;
}

export default function SearchVolumeTreeChart(props: Props) {
    const {relatedTerms, width, height, onClickRelated} = props;
    const series = useMemo(() => {
        return relatedTerms.map((term: BolSearchTerm) => ({
            name: term.search_term,
            data: [{x: term.search_term, y: term.total}]
        }));
    }, [relatedTerms]);
    const options = useMemo(() => {
        const options: any = {
            chart: {
                toolbar: {show: false},
                events: {click: onClick}
            },
            theme: {
                monochrome: {enabled: true}
            }
        };
        return options;
    }, [onClick, relatedTerms]);

    function onClick(evt: React.MouseEvent, _chart?: Chart, options?: any) {
        if (!options?.seriesIndex) return;
        const {seriesIndex} = options;
        if (seriesIndex >= relatedTerms.length) return;
        const relatedTerm = relatedTerms[seriesIndex];
        if (!relatedTerm) return;
        onClickRelated(relatedTerm.search_term)(evt);
        window.scroll({top: 0, behavior: 'smooth'});
    }

    return (
        <div className='search-volume-tree-chart'>
            <Chart options={options} series={series} type='treemap' width={width} height={height} />
        </div>
    );
}
